import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import TournamentsList from './TournamentsList';
import { api } from '../../AppConfig';


function Tournaments() {
  // Access the client
  const queryClient = useQueryClient();

  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const byesQuery = useQuery({ 
    queryKey: ['tournaments'], 
    queryFn: () => 
      fetch(api.tournaments().list().href).then((res) =>
        res.json(), 
      )
  })

  return <TournamentsList 
            pending={byesQuery.isPending} 
            tournaments={byesQuery.data} 
  />;
}

export default Tournaments;